export default __webpack_public_path__ + "static/media/logo.fd1be830.png";